import { SLICE_TAG } from '@/constants';
import { apiSlice } from '@/features/slice/api-slice';

import { TransactionResponseSchema } from './transaction.schema';

export const transactionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query({
      query: (searchParams) => {
        return {
          url: `accounting/transactions`,
          method: 'GET',
          params: searchParams,
        };
      },
      transformResponse: (response) => {
        return TransactionResponseSchema.parse(response);
      },
      keepUnusedDataFor: 600,
      providesTags: [SLICE_TAG.TRANSACTION],
    }),
  }),
});

export const { useGetTransactionsQuery, useLazyGetTransactionsQuery } =
  transactionApi;
